import * as v from "valibot";
import { Ref } from "vue";

import { useLocalStorageBackedRef } from "@/store/stores/base";

export type Selection<E> =
  | {
      mode: "all";
    }
  | {
      mode: "all_except";
      items: E[];
    }
  | {
      mode: "some";
      items: E[];
    };

export const NO_IDS_SENTINEL = ",";

export const createIds = (selection: Selection<{ id: string }>): string => {
  switch (selection.mode) {
    case "all": {
      return "all";
    }
    case "all_except": {
      return selection.items.length === 0 ? "all" : NO_IDS_SENTINEL;
    }
    case "some": {
      return (
        selection.items.map((event) => event.id).join(",") || NO_IDS_SENTINEL
      );
    }
  }
};

export type ColumnSpec<Column> = {
  label: string;
  columns: {
    key: Column;
    always?: boolean;
    default?: boolean;
    label: string;
  }[];
}[];

const persistedColumnsSchema = v.array(v.string());

export const useColumnSpec = (
  id: string,
  spec: ColumnSpec<string>
): Ref<string[]> => {
  const defaultColumns = spec.flatMap((section) =>
    section.columns
      .filter((column) => column.default)
      .map((column) => column.key)
  );

  const columns = useLocalStorageBackedRef<string[]>(
    `columns:${id}`,
    defaultColumns,
    (value) => {
      return JSON.stringify(value);
    },
    (value) => {
      try {
        const parsed = JSON.parse(value);
        const validated = v.parse(persistedColumnsSchema, parsed);

        return validated;
      } catch {
        /* empty */
      }

      return defaultColumns;
    }
  );
  return columns;
};
